import {
  MSAL_CONFIG_AUTHORITY,
  MSAL_CONFIG_CLIENT_ID,
  MSAL_CONFIG_REDIRECT_URL,
  MSAL_CONFIG_EXPOSED_API_SCOPE,
  LOGIN_STATE,
  LEMONSOFT_B2C_AUTHORITY,
  LEMONSOFT_B2C_REDIRECT_URL,
  LEMONSOFT_B2C_CLIENT_ID,
  LEMONSOFT_B2C_SCOPE,
  FINVOICER_URL,
  FINVOICER_CLIENT_ID,
} from 'config/env'

export const msalConfig = {
  auth: {
    authority: MSAL_CONFIG_AUTHORITY,
    clientId: MSAL_CONFIG_CLIENT_ID,
    redirectUri: MSAL_CONFIG_REDIRECT_URL,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}
export const loginRequest = {
  // scopes: ['User.Read'],
  scopes: [MSAL_CONFIG_EXPOSED_API_SCOPE],
  state: LOGIN_STATE,
}

export const lemonsoftConfig = {
  auth: {
    authority: LEMONSOFT_B2C_AUTHORITY,
    redirectUri: LEMONSOFT_B2C_REDIRECT_URL,
    clientId: LEMONSOFT_B2C_CLIENT_ID,
    knownAuthorities: [LEMONSOFT_B2C_AUTHORITY],
    validateAuthority: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const lemonsoftRequest = {
  scopes: [LEMONSOFT_B2C_SCOPE],
}

export const finvoicerConfig = {
  url: FINVOICER_URL,
  clientId: FINVOICER_CLIENT_ID,
}
